import React from 'react'
import './style.css'

const Button = props => {
return <div onClick={props.onClick} style={props.small?{fontSize:"1.4em"}:null} className={props.white ?"whiteBtn"  :"cta"}>{props.title}</div>
}

export default Button